(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["thalise-shop-by-colour"] && !Shopify.designMode) return;
  try {
    
  function initColourPalettes(scope) {
    scope.querySelectorAll('[data-colour-palette]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const track = root.querySelector('.thalise-colour-boxes__track');
      const arrows = root.querySelector('.thalise-colour-boxes__arrows');
      const buttons = [...arrows.querySelectorAll('button')];
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        arrows.hidden = max < 2;
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft >= max - 2;
      };
      buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({ left: Number(button.dataset.colourScroll) * track.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  initColourPalettes(document);
  document.addEventListener('shopify:section:load', event => initColourPalettes(event.target));

  } catch(e) { console.error(e); }
})();
})();
